import React, { createContext, useState, useContext, useEffect } from 'react';

// Mocks temporales para servicios de autenticación
const loginService = async (email, password) => {
  // Mock de login exitoso
  return {
    token: 'mock-jwt-token',
    user: {
      id: 1,
      name: 'José Tapia',
      email: email || 'trainer@altchat.io',
      role: 'trainer'
    }
  };
};

const logoutService = async () => {
  // Mock de logout exitoso
  return true;
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Verificar si hay un usuario en localStorage al cargar
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      setCurrentUser(JSON.parse(user));
    }
    
    setLoading(false);
  }, []);
  
  const login = async (email, password) => {
    try {
      const response = await loginService(email, password);
      const { token, user } = response;
      
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      setCurrentUser(user);
      return true;
    } catch (error) {
      console.error('Error en login:', error);
      return false;
    }
  };
  
  const logout = async () => {
    try {
      await logoutService();
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setCurrentUser(null);
    } catch (error) {
      console.error('Error en logout:', error);
    }
  };
  
  const value = {
    currentUser,
    login,
    logout,
    loading
  };
  
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};